import { LookupKeys } from '@ag-common-lib/lib/models/crm/lookup.model';

export enum TextAlignment {
  start = 'start',
  center = 'center',
  end = 'end',
}

export const TextAlignmentMap = new Map([
  [TextAlignment.start, 'Left'],
  [TextAlignment.center, 'Center'],
  [TextAlignment.end, 'Right'],
]);

export const TEXT_ALIGNMENT_LOOKUP = [TextAlignment.start, TextAlignment.center, TextAlignment.end].map(value => {
  return { [LookupKeys.value]: value, [LookupKeys.description]: TextAlignmentMap.get(value) };
});
